export default {
  container: 'flex p-[1.5em] hover:bg-[#F0F3F6] cursor-pointer rounded-lg',
  text: 'font-inter text-[16px]',
};
